export const features = [
  [
    {
      subtitle: 'home.functional.guarantee.title',
      subdescription: 'home.functional.guarantee.description',
      imgClass: 'guarantee'
    },
    {
      subtitle: 'home.functional.support.title',
      subdescription: 'home.functional.support.description',
      imgClass: 'support'
    }
  ],
  [
    {
      subtitle: 'home.functional.compliance.title',
      subdescription: 'home.functional.compliance.description',
      imgClass: 'compliance'
    },
    {
      subtitle: 'home.functional.types.title',
      subdescription: 'home.functional.types.description',
      imgClass: 'types'
    }
  ],
  [
    {
      subtitle: 'home.functional.business.title',
      subdescription: 'home.functional.business.description',
      imgClass: 'business'
    },
    {
      subtitle: 'home.functional.storage.title',
      subdescription: 'home.functional.storage.description',
      imgClass: 'virtual_server'
    }
  ],
  [
    {
      subtitle: 'home.functional.aggregated.title',
      subdescription: 'home.functional.aggregated.description',
      imgClass: 'aggregated'
    },
    {
      subtitle: 'home.functional.backups.title',
      subdescription: 'home.functional.backups.description',
      imgClass: 'backups'
    }
  ]
]

export const opportunitiesList = [
  'virtual_server',
  'resource_management',
  'backups',
  'monitoring',
  'sharing',
  'clonning',
  'networks',
  'security',
  'html5',
  'support'
];

export const devopsFeatures = [
  {
    title: 'devops.features.integration.title',
    description: 'devops.features.integration.description'
  },
  {
    title: 'devops.features.board.title',
    description: 'devops.features.board.description'
  },
  {
    title: 'devops.features.ci.title',
    description: 'devops.features.ci.description'
  }
]
